import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useServiceTemplatesStore } from '@/stores/serviceTemplates'
import { useSearchStore } from '@/stores/search'
import { useQueryParams } from '@/router/useQueryParams'
import { useSlugHelper } from '@/router/useSlugHelper'
import { useSettingsStore } from '@/stores/settings'

const Config: TrPageConfigInterface = {
  path: '/services/:slug',
  alias: '/services/:slug',
  component: () => import('@page/service/PageService.vue'),
  beforeEnter: async (to, from, next) => {
    const queryParams = useQueryParams(to)
    const searchStory = useSearchStore()
    searchStory.resetSearchCalled()
    queryParams.extractSearchParams()

    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })

    await useSettingsStore().fetchGlobalSettings()

    const serviceTemplatesStore = useServiceTemplatesStore()
    serviceTemplatesStore.currentVisitedServiceTemplate = null
    serviceTemplatesStore.currentServiceTemplate = null

    if (!serviceTemplatesStore.currentVisitedServiceTemplate?.id) {
      await serviceTemplatesStore.fetchServiceTemplateWithSlug(to.params.slug)
    }

    loadingStore.toggleLoading({ set: false })

    next(
      await useSlugHelper().checkServiceSlug(to.params.slug, {
        fr: serviceTemplatesStore.currentVisitedServiceTemplate.slugFr,
        en: serviceTemplatesStore.currentVisitedServiceTemplate.slugEn
      })
    )
  }
}

export { Config }
